<template>
  <div
      v-observe-visibility="observeViews"
      class="my-4"
      v-bind:class="{ pinned: pinned }"
  >
    <div v-if="pinned" class="pinned-title mb-3">
      <button
          class="border-0 mr-2 bg-transparent"
          @click="unpinPost"
          v-if="canEditPost"
      >
        <i class="fas fa-thumbtack"></i>
      </button>
      <i class="fas fa-thumbtack mr-2" v-else></i>
      Pinned
    </div>
    <div class="d-flex flex-row">
      <div class="mr-2 d-flex align-items-center">
        <div class="mr-2">
          <user-avatar :avatarURL="activityFeed.owner.avatar_src"></user-avatar>
        </div>
      </div>
      <div style="flex: 1">
        <div class="d-flex flex-row align-items-center">
          <div class="d-flex flex-column">
            <div class="name mr-2">
              {{
                activityFeed.owner.display_name
                    ? activityFeed.owner.display_name
                    : activityFeed.owner.name
              }}
            </div>
            <div class="d-flex align-items-center">
              <div class="time">
                {{
                  timeFormatter.displayFullDateTime(
                      new Date(activityFeed.created_at),
                  )
                }}
              </div>
              <div class="ml-2 visibility" v-if="currentUser.id === activityFeed.owner_id && activityFeed.visibility">
                <div>{{ displayVisibility(activityFeed.visibility) }}</div>
              </div>
            </div>
          </div>
          <div style="margin: 0 0 0 auto">
            <div class="dropdown" v-if="canEditPost">
              <button
                  class="btn btn-link dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style="padding: 0 !important; outline: none; box-shadow: none"
              >
                <i class="fas fa-ellipsis-h" style="color: #1d1d1d"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <button
                    class="dropdown-item wfh-dropdown-bg"
                    @click="pinPost"
                    v-if="isAdmin"
                >
                  {{ pinned ? 'Unpin' : 'Pin' }} message
                </button>
                <button
                    class="dropdown-item wfh-dropdown-bg"
                    v-if="currentUser.id === activityFeed.owner_id"
                    @click="editActivityFeed"
                >
                  Edit
                </button>
                <button
                    class="dropdown-item wfh-dropdown-bg"
                    v-if="isAdmin || currentUser.id === activityFeed.owner_id"
                    @click="deleteActivityFeed"
                >
                  Delete
                </button>
                <select
                    class="dropdown-item form-control"
                    v-if="isAdmin || currentUser.id === activityFeed.owner_id"
                    v-model="activityFeed.visibility"
                    style="padding: 0 21px"
                    @click="clickPrevent"
                    @change="updateVisibility"
                >
                  <option value="public">Public</option>
                  <option
                      v-for="userGroup of userGroups"
                      :value="'team_' + userGroup.id"
                      :key="userGroup.id"
                  >
                    {{ userGroup.name }} team only
                  </option>
                  <option value="company">My company only</option>
                  <option value="private">Only me</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-2">
      <MetaSection
          v-if="postWithMeta"
          :description="meta.description"
          :image="meta.image"
          :title="meta.title"
          :url="meta.url"
          :canDelete="false"
      />
      <div class="feed-content my-1">
        <span :class="{ resized: resize }" v-html="content"></span>
        <button v-if="resize" class="btn btn-link p-0" @click="toggleResize">
          View more
        </button>
      </div>
      <div class="my-1 d-flex justify-content-center" v-if="activityFeed.image">
        <img
            :src="activityFeed.image"
            alt="Post image"
            style="max-height: 200px; max-width: 100%"
        />
      </div>

      <div class="my-1 d-flex flex-row align-items-center">
        <button
            class="btn btn-link mr-1"
            style="padding: 0 !important"
            @click="toggleLike"
        >
          <i
              v-bind:class="{
              far: !liked,
              fas: liked,
              likedHeart: liked,
              unlikedHeart: !liked,
            }"
              class="fa-heart"
          ></i>
        </button>
        <div class="like-text">
          {{ likeText }}
        </div>
      </div>

      <div class="my-2">
        <div
            v-for="comment in comments.data"
            :key="comment.id"
            class="my-1 d-flex flex-row"
        >
          <div class="mr-2">
            <div class="mr-2">
              <user-avatar :avatarURL="comment.owner.avatar_src"></user-avatar>
            </div>
          </div>
          <div class="flex-fill">
            <div class="d-flex flex-row flex-wrap">
              <div class="d-flex flex-column">
                <div class="name" style="font-size: 12px; line-height: 12px">
                  {{
                    comment.owner.display_name
                        ? comment.owner.display_name
                        : comment.owner.name
                  }}
                </div>
                <div class="time" style="font-size: 12px">
                  {{
                    timeFormatter.displayFullDateTime(
                        new Date(comment.created_at),
                    )
                  }}
                </div>
              </div>

              <div
                  class="flex-fill text-right"
                  v-if="currentUserIsCommentOwner(comment)"
              >
                <div style="margin: 0 0 0 auto">
                  <div class="dropdown">
                    <button
                        class="btn btn-link dropdown-toggle"
                        type="button"
                        :id="`comment_${comment.id}`"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        style="
                        padding: 0 !important;
                        outline: none;
                        box-shadow: none;
                      "
                    >
                      <i class="fas fa-ellipsis-h" style="color: #1d1d1d"></i>
                    </button>
                    <div
                        class="dropdown-menu comment"
                        :aria-labelledby="`comment_${comment.id}`"
                    >
                      <button
                          class="dropdown-item wfh-dropdown-bg"
                          @click="deleteComment(comment)"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="feed-content my-1" v-html="comment.content"></div>
          </div>
        </div>

        <div class="text-center my-1">
          <!-- Show loading state if request sent -->
          <template v-if="comments.loading">
            <button
                class="btn btn-link font-weight-bold"
                :disabled="comments.loading"
                @click="clickPrevent()"
            >
              <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
              ></span>
              <span class="sr-only">Loading comments...</span>
            </button>
          </template>

          <!-- Show the remaining comments available -->
          <template v-else-if="comments.currentPage < commentsTotalPage">
            <button
                class="btn btn-link font-weight-bold"
                @click="getMoreComments()"
            >
              {{ remainingComments }} more comment(s)
            </button>
          </template>

          <!-- When there's no more comments -->
          <template v-else>
            <button
                class="btn btn-link font-weight-bold text-muted"
                disabled
                @click="clickPrevent()"
            >
              No more comment
            </button>
          </template>
        </div>

        <div class="comment-cke" :class="{ pinned: pinned }">
          <ckeditor-wfh v-model="comment"></ckeditor-wfh>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Timeformatter from './Timeformatter';
import MetaSection from '../Misc/MetaSection';
import Swal from 'sweetalert2';

export default {
  components: { MetaSection },

  props: ['activityFeed', 'pinned', 'company', 'userGroups'],

  data () {
    return {
      resize: false,
      content: '',
      comment: '',
      timeFormatter: Timeformatter,
      liked: false,
      likeText: '',
      postWithMeta: false,
      meta: {},
      comments: {
        loading: false,
        perPage: 2,
        currentPage: 1,
        total: 0,
        data: [],
      },
    };
  },

  watch: {
    activityFeed () {
      this.initPaginatedComments();
    },

    'activityFeed.likes' () {
      this.getLikeText();
    },

    currentUser () {
      this.getLikeText();
    },

    comment () {
      if (this.comment === '') {
        return;
      }

      const enterRegex = /(<p>&nbsp;<\/p>)/;

      if (this.comment.match(enterRegex) !== null) {
        this.comment = this.comment.replace(enterRegex, '');
        this.submitComment();
      }
    },

    resize () {
      if (this.resize) {
        this.content = this.activityFeed.content.substring(0, 150) + ' ...';
      } else {
        this.content = this.activityFeed.content;
      }
    },
  },

  computed: {
    currentUser () {
      return this.$store.state.currentUser;
    },

    canEditPost () {
      if (!this.currentUser.role || !this.activityFeed.owner) return;

      if (!this.activityFeed || !this.currentUser || !this.company) {
        return false;
      } else {
        return (
            (this.isAdmin &&
                this.activityFeed.owner.company.id === this.company.id) ||
            this.currentUser.id === this.activityFeed.owner_id
        );
      }
    },

    isAdmin () {
      return this.$store.state.isAdmin;
    },

    commentsTotalPage () {
      return Math.ceil(this.comments.total / this.comments.perPage);
    },

    remainingComments () {
      return (
          this.comments.total - this.comments.perPage * this.comments.currentPage
      );
    },

    viewed () {
      return this.activityFeed.views.length !== 0;
    },

    observeViews () {
      return this.activityFeed.views.length === 0
          ? {
            callback: this.postViewed,
            once: true,
            throttle: 2000,
          }
          : false;
    },

    teamNames() {
      const teamMap = {};
      this.userGroups.forEach(userGroup => {
        teamMap['team_' + userGroup.id] = userGroup.name;
      });
      return teamMap;
    },

    displayVisibility() {
      return (visibility) => {
        if (visibility === 'public') {
          return 'Public';
        } else if (visibility.startsWith('team_')) {
          const teamId = visibility;
          const teamName = this.teamNames[teamId];
          if (teamName) {
            return `${teamName} team only`;
          }
        } else if (visibility === 'company') {
          return 'My company only';
        } else if (visibility === 'private') {
          return 'Only me';
        }
      };
    },
  },

  methods: {
    clickPrevent (e) {
      e.stopPropagation();
      e.preventDefault();
    },

    async submitComment () {
      await axios.post(`activity-feeds/${this.activityFeed.id}/comment`, {
        comment: this.comment,
      });

      this.$emit('refreshFeed');
      this.comment = '';
    },

    async toggleLike () {
      this.liked = !this.liked;

      await axios.post(`activity-feeds/${this.activityFeed.id}/like`);
      this.$emit('refreshFeed');
    },

    getLikeText () {
      let text = '';
      let counter = 0;
      let threshold = 2;

      if (!this.activityFeed.likes) {
        return;
      }

      const total = this.activityFeed.likes.length;

      // The current user will always be the first one
      if (
          this.activityFeed.likes.findIndex((i) => i.id == this.currentUser.id) >
          -1
      ) {
        text += ' You,';
        this.liked = true;

        counter++;
      }

      this.activityFeed.likes.forEach((item) => {
        // Adding threshold for limitter
        if (counter >= threshold) {
          return false;
        }

        // Skip if the user is current user
        if (item.id == this.currentUser.id) {
          return true;
        }

        text += ` ${item.display_name ? item.display_name : item.name},`;

        counter++;
      });

      if (text) {
        text = text.substring(1, text.length - 1);

        // const texts = text.replace(' ', '').split(',');
        // text = texts.join(',');
      }

      if (total > counter) {
        text += ` & ${total - counter} others`;
      }

      this.likeText = text;
    },

    async pinPost () {
      await axios.post(`activity-feeds/${this.activityFeed.id}/pin`);
      this.$emit('refreshFeed');
    },

    async unpinPost () {
      await axios.post(`activity-feeds/${this.activityFeed.id}/unpin`);
      this.$emit('refreshFeed');
    },

    async updateVisibility () {
      await axios.post(`activity-feeds/${this.activityFeed.id}/visibility`, {
        visibility: this.activityFeed.visibility,
      });
      this.$emit('refreshFeed');
    },

    async deleteActivityFeed () {
      await axios.delete(`activity-feeds/${this.activityFeed.id}`);
      this.$emit('refreshFeed');
    },

    editActivityFeed () {
      this.$emit('editFeed', this.activityFeed);
    },

    identifyPostMetadata () {
      const meta = this.activityFeed.meta;

      if (meta.length > 0) {
        meta.forEach((meta) => {
          this.meta[meta.name] = meta.value;
        });
      }

      this.postWithMeta =
          Object.keys(this.meta).length > 0 && this.meta.url !== null;
    },

    async deleteComment (comment) {
      const response = await Swal.fire({
        icon: 'question',
        title: 'Delete Comment',
        html: 'Are you sure you want to delete your comment? The comment will be deleted permanently.',
        focusCancel: true,
        confirmButtonColor: 'red',
        confirmButtonText: 'Delete Comment',
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
      });

      if (response.isConfirmed) {
        await axios.delete('/comments', {
          params: {
            comment_ids: [comment.id_hash],
          },
        });

        this.comments.data = this.comments.data.filter((item) => {
          return item.id_hash !== comment.id_hash;
        });
      }
    },

    currentUserIsCommentOwner (comment) {
      return this.currentUser.id === comment.owner.id;
    },

    async initPaginatedComments () {
      await this.getComments();
    },

    async getMoreComments () {
      this.comments.currentPage += 1;
      await this.getComments();
    },

    async getComments () {
      if (this.comments.loading) return;
      if (!this.activityFeed.id) return;

      try {
        this.comments.loading = true;

        let { data } = await axios.get(
            `activity-feeds/${this.activityFeed.id}/comment`,
            {
              params: {
                per_page: this.comments.perPage,
                page: this.comments.currentPage,
              },
            },
        );

        let result = data.data;
        this.comments.total = result.total;
        this.comments.data = [...this.comments.data, ...result.data];
      } catch (error) {}

      this.comments.loading = false;
    },

    async postViewed (isVisible) {
      if (!this.viewed && isVisible) {
        try {
          await axios.post(`activity-feeds/${this.activityFeed.id}/viewed`);
        } catch (error) {}
      }
    },

    initContent () {
      this.content = this.activityFeed.content;
    },

    checkContentResize () {
      if (
          this.activityFeed.views.length > 0 &&
          this.activityFeed.content.length > 150
      ) {
        this.resize = true;
      }
    },

    toggleResize () {
      this.resize = !this.resize;
    },
  },

  mounted () {
    this.identifyPostMetadata();
    this.getLikeText();
    this.initPaginatedComments();
    this.initContent();
    this.checkContentResize();
  },
};
</script>

<style scoped lang="scss">
.name {
  color: #303030;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
}

.visibility {
  opacity: 0.7;
}
.time , .visibility {
  color: #808fa4;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 22px;
}

.comment {
  color: #303030;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
  white-space: pre-wrap;
}

.wfh-input {
  border-radius: 3px;
  background-color: #f2f2f2;
  border: none;
}

.wfh-input:active,
.wfh-input:focus-within {
  background-color: #fff;
}

.likedHeart {
  color: #ff8383;
}

.unlikedHeart {
  color: #9696a8;
}

.like-text {
  color: #303030;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 15px;
}

.pinned {
  border-radius: 8px;
  background-color: #f2f4f5;
  padding: 17px;
}

.dropdown-menu {
  left: auto !important;
  right: 0;
  &.comment {
    right:auto !important
  }
}

.pinned-title {
  color: #303030;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
}

.wfh-dropdown-bg:hover {
  background-color: #3592ff !important;
  color: #fff !important;
}
</style>

<style lang="scss">
.feed-content .resized > p {
  margin-bottom: 0;
}
</style>
